import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Affected, AFFECTED_PARTY_TYPE_LABELS } from '../../_types/affected';
import { AffectedsService } from '../../_services/affecteds.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CountriesService } from 'src/app/modules/common/_services/countries.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { AddressesService } from 'src/app/modules/common/_services/addresses.service';
import { Address } from 'src/app/modules/common/_types/address';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-affected',
    templateUrl: './affected.component.html',
    styleUrls: ['./affected.component.scss'],
    standalone: false
})
export class CasesDetailAffectedComponent {
  public affectedFormGroup!: RxFormGroup;

  public affected: Affected = new Affected();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public arrayTypeAffected = AFFECTED_PARTY_TYPE_LABELS;
  public countries: any = [];

  constructor(
    private affectedsService: AffectedsService,
    private addressesService: AddressesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private countriesService: CountriesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private loginService: LoginService
  ) {
    this.affectedFormGroup = this.formBuilder.formGroup<Affected>(this.affected) as RxFormGroup;
  }

  async ngOnInit() {
    this.loadCountries();

    let id = this.config.data.affectedId;
    if (id != null && id != '0') {
      await this.loadAffected(id);
    } else {
      this.affected.caseId = this.config.data.caseId;
    }

    if (this.affected.address == null) this.affected.address = new Address();

    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");

  }

  async loadAffected(id: string) {
    this.affected = await firstValueFrom(this.affectedsService.get(id, { include: ['address', 'case'] }));
    this.affectedFormGroup.patchValue(this.affected);
  }

  async loadCountries() {
    let params: IParamsCollection= {
      sort: ['name']
    };
    let response = await firstValueFrom(this.countriesService.all(params));
    this.countries = response.data;
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.affectedFormGroup);
    if (valid) {
      this.affected = Object.assign(this.affected, this.affectedFormGroup.value);

      if (this.affected.address != null) {
        let address: any = await firstValueFrom(this.addressesService.save(this.affected.address));
        this.affected.addressId = address.id;
      }

      let affected = await firstValueFrom(this.affectedsService.save(this.affected));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Perjudicado guardado correctamente." });

      this.dynamicDialogRef.close();

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
